import { EmailCard } from "components/EmailCard/EmailCard";
import dayjs from "dayjs";
import type { EmailSearchInput } from "hooks/useEmailsRestApi";
import type { FC, RefObject } from "react";
import type { EmailWithStatus } from "routes/emails/SearchEmailsPage";

export type MatterEmailsCardsUIProps = {
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  onOpenDetail?: (id: string) => void;
  onToggleFavoriteEmail: (emailId: string, favorite: boolean) => void;
  currentSearchInput: EmailSearchInput;
  scrollCardRef: RefObject<HTMLDivElement>;
  scrollCardId: string | null;
  selectedId?: string | null;
};

export const MatterEmailsCardsUI: FC<MatterEmailsCardsUIProps> = ({
  emails,
  onSelectEmail,
  onOpenDetail,
  onToggleFavoriteEmail,
  currentSearchInput,
  scrollCardRef,
  scrollCardId,
  selectedId = null,
}) => {
  if (emails.length === 0) {
    return (
      <div className="flex justify-center">
        <div className="text-left text-gray-500 max-w-xl">
          <p>条件に合う検索結果はありません。</p>
          <div className="h-4" />
          <p>あるいは、あなたのアカウントがどの会社にも紐づいていません。</p>
          <p>管理者にアカウントと所属会社の紐づけ作業を依頼してください。</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {emails.map(email => (
        <EmailCard
          key={email.id}
          isMatter={true}
          emailId={email.id}
          onSelectEmail={onSelectEmail}
          onOpenDetail={onOpenDetail}
          onToggleFavoriteEmail={onToggleFavoriteEmail}
          isSelected={email.id === selectedId}
          favorite={email.favorite}
          title={email.subject}
          date={dayjs(email.date).toString()}
          period={email.matterColumn?.period || null}
          content={email.content}
          reward={email.matterColumn?.reward || null}
          isRemoteEnabled={email.matterColumn?.isRemoteEnabled || false}
          station={email.matterColumn?.station || null}
          numberOfInterviews={email.matterColumn?.numberOfInterviews || null}
          otherCountriesEnabled={
            email.matterColumn?.otherCountriesEnabled || false
          }
          onlyEnableFreelance={
            currentSearchInput.matterFilter?.onlyEnableFreelance || false
          }
          workingTimeWidth={email.matterColumn?.workingTimeWidth || null}
          endOrPrimeContractorDirect={
            email.matterColumn?.endOrPrimeContractorDirect || null
          }
          depth={email.matterColumn?.depth ?? null}
          technology={email.matterColumn?.technology || null}
          industryCategory={email.matterColumn?.industryCategory || null}
          remoteFrequency={email.matterColumn?.remoteFrequency || null}
          isRead={email.read}
          hasAttachments={email.hasAttachments}
          duplicateCount={email.duplicateCount}
          inReplyToMessageId={email.inReplyToMessageId}
          scrollCardRef={scrollCardRef}
          scrollCardId={scrollCardId}
        />
      ))}
    </div>
  );
};
